import { useSelector } from 'react-redux'

import type { IState } from 'types/redux'
import {
  hasNoPurchaseHistoryOverdraftsSelector,
  hasOverdraftsSelector,
  maxDosageDetailsSelector,
} from 'views/components/organisms/Cart/selectors'

/**
 * Returns max dosage related values from state
 */
export const useMaxDosageValues = () => {
  const isCollectiveOrderStatus = useSelector(
    (state: IState) => state.cart.data?.collectiveOrder
  )
  const hasOverdrafts = useSelector(hasOverdraftsSelector)
  const hasNoPurchaseHistoryOverdrafts = useSelector(
    hasNoPurchaseHistoryOverdraftsSelector
  )

  const isUserLoggedIn = useSelector(
    (state: IState) => state.userSession.newLogin
  )

  const maxDosageDetails = useSelector(maxDosageDetailsSelector)
  return {
    hasOverdrafts,
    isCollectiveOrderStatus,
    hasNoPurchaseHistoryOverdrafts,
    isForMaxDosageLoggedInUser: isUserLoggedIn,
    maxDosageDetails,
  }
}
